$ = require 'jquery'
BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'
ChangeBoardAddMemberPermsView = require 'views/board-menu/change-board-add-member-perms-view'
ChangeBoardCommentingPermsView = require 'views/board-menu/change-board-commenting-perms-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class BoardSettingsView extends View
  viewTitleKey: 'settings'

  className: 'board-menu-content-frame'

  events:
    'click .js-change-org:not(.disabled)': 'changeOrg'

    'click .js-toggle-covers:not(.disabled)': 'toggleCovers'

    'click .js-change-comments:not(.disabled)': 'changeCommentingPerms'
    'click .js-change-add-members:not(.disabled)': 'changeAddMemberPerms'

    'click .js-toggle-org-mem-join:not(.disabled)': 'toggleSelfJoin'

  initialize: ->
    @listenTo @model, 'change', @frameDebounce @render
    return

  render: ->
    data = @model.toJSON { prefs: true, url: true, labels: true }

    data.cardCovers = data.prefs.cardCovers
    organization = @model.getOrganization()
    data.orgDisplayName = organization?.get('displayName')
    data.hasOrg = organization?.id?

    data.commentsDisplay = l(['board pref perms', @model.getCommentPerm()])
    data.invitationsDisplay = l(['board pref perms', @model.getInvitePerm()])

    # If you're the org owner, you can change the organization to nothing
    # If you're the board owner, you can change the organization to whatever
    data.canChangeOrg = organization?.owned() || @model.owned()

    if organization?.owned() && !@model.owned()
      data.setOrgNull = true

    @$el.html(
      templates.fill(
        'board_menu_settings',
        data,
        { editable: @model.editable(), owned: @model.owned() }
      )
    )

    @

  changeOrg: (e) ->
    Util.stop(e)

    if @model.owned()

      PopOver.toggle
        elem: $(e.target).closest('a')
        view: BoardSelectOrganizationView
        options: { @model, @modelCache }

      track("Board Menu", "Settings", "Change Org")

    else
      idOrg = @model.get('idOrganization')
      @modelCache.get('Organization', idOrg)?.boardList.remove(@model)
      @model.update 'idOrganization', ''
      PopOver.hide()
      track("Board Menu", "Settings", "Remove Org")

    return

  toggleCovers: (e, cardCovers) ->
    Util.stop(e)

    @model.setPref('cardCovers', !@model.getPref('cardCovers'))

    track("Board Menu", "Settings", "Enable/Disable Cover Images")

    return

  changeCommentingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardCommentingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Commenting Permissions")

    return

  changeAddMemberPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardAddMemberPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Add Member Permissions")

    return

  toggleSelfJoin: (e) ->
    Util.stop(e)

    @model.setPref('selfJoin', !@model.getPref('selfJoin'))
    @model.save()

    track("Board Menu", "Settings", "Toggle Allow Org Join")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-settings-view.coffee